/**************************************************
 * Nombre:       Seccion_Testimonios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {theme} from "../../Tema";
import {where} from "firebase/firestore";
import {usuarioContext} from "../../App";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import Tarjeta_Testimonio from "../Tarjetas/Tarjeta_Testimonio";
import {useParams} from "react-router-dom";


const Seccion_Testimonios = () => {
    const cData = useContext(usuarioContext)
    const parms = useParams()
    const {sCell} = useResponsive()
    const [testimonios, setTestimonios] = useState([])
    const [idEscogido, setIdEscogido] = useState('');


    useEffect(() => {

        let w = [where('estado', '==', "Publicado")]
        obtenerColWheres({col: 'testimonios', wheres: w}).then((dox) => {
            if (dox.res) {
                setTestimonios(dox.data)
            }
        })

    }, [cData])

    useEffect(() => {

        if (parms && parms.id) {
            setIdEscogido(parms.id);
        }

    }, [parms]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={0}
            >


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: sCell ? 32 : 36,
                                        fontWeight: 800,
                                        lineHeight: 1.1
                                    }}>
                                        Testimonios
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 9}}
                                      sx={{justifyContent: 'flex-start', mt: sCell ? 1.5 : 0}}>
                                    <Typography sx={{fontSize: 14, fontWeight: 400}}>
                                        Testimonios de personas que probaron con esta tecnologia y muestran sus
                                        resultados al mundo
                                    </Typography>
                                </Grid>


                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', mt: 12, px: sCell ? 0 : 4}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={8}
                    >

                        {testimonios.map((it, index) => (
                            <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Testimonio  escogida={idEscogido}  item={it}/>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Testimonios


const documentos = [
    {
        nombre: 'Documento Uno',
    },
    {
        nombre: 'Documento Dos',
    },
    {
        nombre: 'Documento Tres',
    },
    {
        nombre: 'Documento Cuatro',
    },
]